import { memo } from 'react';
import type { Message } from '../../../api/types';
import { MessageListSkeleton } from '../../shared';
import styles from './MessageList.module.css';
import { MessageBubble } from '../MessageBubble';

export interface MessageListProps {
  messages: Message[];
  isLoading?: boolean;
  emptyMessage?: string;
  variant?: 'default' | 'compact' | 'floating';
  maxHeight?: string;
  className?: string;
}

export function MessageList({
  messages,
  isLoading = false,
  emptyMessage = "Hi! I'm DevXGPT. How can I help you today?",
  variant = 'default',
  maxHeight,
  className = '',
}: MessageListProps) {
  

  if (isLoading && messages.length === 0) {
    return (
      <div className={`${styles.messages} ${styles[variant]} ${className}`} style={maxHeight ? { maxHeight } : undefined}>
        <MessageListSkeleton count={1} />
      </div>
    );
  }

  if (messages.length === 0) {
    return (
      <div className={`${styles.messages} ${styles[variant]} ${className}`} style={maxHeight ? { maxHeight } : undefined}>
        <div className={`${styles.message} ${styles.messageAssistant}`}>
          <div className={styles.messageContent}>{emptyMessage}</div>
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.messages} ${styles[variant]} ${className}`} style={maxHeight ? { maxHeight } : undefined}>
      {messages.map((msg) => (
        <MessageBubble key={msg.id} message={msg} variant={variant} />
      ))}
    </div>
  );
}

// Memoize for performance if streaming updates are frequent
export const MemoizedMessageList = memo(MessageList);